import type { ReceiptFeedback } from './receiptsTypes';
import { RECEIPT_FEEDBACK_REASON_ORDER, ReceiptFeedbackRating, type ReceiptFeedbackReason } from './receiptsTypes';

export const RECEIPT_FEEDBACK_REASON_LABELS: Record<ReceiptFeedbackReason, string> = {
  PAYEE_NAME: 'Payee name',
  DATE: 'Receipt date',
  RECEIPT_TOTAL: 'Receipt total',
  ITEMS: 'Items',
  SUBTOTAL_TIPS_TAXES_DISCOUNTS: 'Subtotal, tips, taxes & discounts',
  OTHER: 'Something else',
};

export { RECEIPT_FEEDBACK_REASON_ORDER };

export const isReceiptFeedbackComplete = (feedback: ReceiptFeedback): boolean =>
  feedback.rating === ReceiptFeedbackRating.POSITIVE || feedback.reasons.length > 0;
